import classNames from 'classnames'

import Image from '../Image/Image'
import styles from './ScrollHandler.module.scss'
import arrowUpRight from '../../../assets/images/arrowUpRight.svg'
import { useLanguage } from '../../../context/LangaugeContextProvider/LangaugeContextProvider'
import { isArabic } from '../../../utils'

const ScrollHandler = ({
  scrollLeftHandler,
  scrollRightHandler,
  isAtStart,
  isAtEnd,
  className,
  avoidRtl,
}) => {
  const { language } = useLanguage()
  const isArabicPage = isArabic(language?.code) && !avoidRtl
  return (
    <div className={classNames(styles.imageContainer, className)}>
      <button
        aria-label={`scroll left`}
        onClick={isArabicPage ? scrollRightHandler : scrollLeftHandler}
        disabled={isAtStart}
      >
        <Image
          src={arrowUpRight}
          className={classNames(isArabicPage ? 'rotate45' : 'rotate225', {
            ['filter-opacity']: isAtStart,
          })}
          alt={'left'}
        />
      </button>
      <button
        aria-label={`scroll right`}
        onClick={isArabicPage ? scrollLeftHandler : scrollRightHandler}
        disabled={isAtEnd}
      >
        <Image
          src={arrowUpRight}
          className={classNames(isArabicPage ? 'rotate225' : 'rotate45', {
            ['filter-opacity']: isAtEnd,
          })}
          alt={'right'}
        />
      </button>
    </div>
  )
}

export default ScrollHandler
